import { useLazyQuery } from "@apollo/client";
import { useCallback } from "react";

import { USER_SEARCH } from "MVVM/GraphQL/userSearch";
import { PRO_PLAYER_SEARCH } from "MVVM/GraphQL/proPlayerSearch";

const UserSearchViewModel = () => {
  const [userSearchQueryRaw, { data, error, loading }] =
    useLazyQuery(USER_SEARCH);
  const userSearchQuery = useCallback(userSearchQueryRaw, []);

  const [
    proPlayerSearchQueryRaw,
    { data: proPlayerData, error: proPlayerError, loading: proPlayerLoading },
  ] = useLazyQuery(PRO_PLAYER_SEARCH);
  const proPlayerSearchQuery = useCallback(proPlayerSearchQueryRaw, []);

  return {
    data,
    error,
    loading,
    userSearchQuery,
    proPlayerData,
    proPlayerError,
    proPlayerLoading,
    proPlayerSearchQuery,
  };
};

export { UserSearchViewModel };
